// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const styles = css`
  img {
    width: 100%;
    margin: 0 auto;
    object-fit: contain;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    img {
      max-height: ${(props) => (props.isPlpQV ? '328px' : 'unset')};
      width: 100%;
    }
  }
  .show-on-mobile {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
    }
  }
  .show-on-desktop {
    display: block;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  .show-on-desktop-only {
    display: none;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
    }
  }
  .show-non-zoom-image {
    display: none;
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => (!props.isZoomEnabled ? ' display: block !important;' : '')}
    }
  }
  .show-non-zoom-image.collection-zoom-enabled {
    display: none !important;
  }
  .show-non-zoom-image.collection-zoom-enabled.bundle-video-desktop {
    @media ${(props) => props.theme.mediaQuery.large} {
      display: block !important;
    }
  }
`;

export const PseudoPdpImg = styled.div`
  .psuedo-pdp-img {
    visibility: hidden;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    font-size: 0;
  }
`;
export default styles;
